import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-52b27227")

_pushScopeId("data-v-52b27227")
const _hoisted_1 = { class: "knPageContent p-grid p-m-0 p-p-0" }
const _hoisted_2 = { class: "p-col-4 p-p-0" }
const _hoisted_3 = { class: "kn-list-item-text" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "p-col-8 p-flex-column newsContainer p-p-0"
}
const _hoisted_7 = { class: "p-col" }
const _hoisted_8 = { class: "h4-text" }
const _hoisted_9 = { class: "p-col" }
const _hoisted_10 = { class: "h4-text" }
const _hoisted_11 = { class: "p-col" }
const _hoisted_12 = {
  key: 1,
  class: "p-col-7 p-d-flex p-ai-center p-jc-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary knNewsDialog",
    visible: _ctx.visibility,
    footer: "footer",
    header: _ctx.$t('newsDialog.title'),
    closable: false,
    modal: ""
  }, {
    footer: _withId(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withId(() => [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 0,
                mode: "indeterminate",
                class: "kn-progress-bar",
                "data-test": "progress-bar"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withId(() => [
      _createVNode(_component_TabView, {
        class: "knTab kn-tab",
        onTabClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emptySelectedNews()))
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.news, (type, index) => {
            return (_openBlock(), _createBlock(_component_TabPanel, {
              key: index,
              header: _ctx.$t(_ctx.typeDescriptor.newsType[index].label)
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_1, [
                  _createVNode("div", _hoisted_2, [
                    _createVNode(_component_Listbox, {
                      class: "kn-list",
                      options: _ctx.news[index],
                      optionLabel: "title",
                      listStyle: "max-height:250px"
                    }, {
                      option: _withId((slotProps) => [
                        _createVNode("div", {
                          class: "kn-list-item",
                          onClick: ($event: any) => (_ctx.getNews(slotProps.option.id))
                        }, [
                          _createVNode(_component_Avatar, {
                            icon: _ctx.typeDescriptor.newsType[slotProps.option.type].className,
                            shape: "circle",
                            size: "medium",
                            style: _ctx.typeDescriptor.newsType[slotProps.option.type].style
                          }, null, 8, ["icon", "style"]),
                          _createVNode("div", _hoisted_3, [
                            _createVNode("span", null, _toDisplayString(slotProps.option.title), 1)
                          ]),
                          (slotProps.option.read)
                            ? (_openBlock(), _createBlock("span", _hoisted_4, [
                                _createVNode(_component_Avatar, {
                                  icon: _ctx.typeDescriptor.icons.read.icon,
                                  shape: "circle",
                                  size: "medium",
                                  style: _ctx.typeDescriptor.icons.read.style
                                }, null, 8, ["icon", "style"])
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_5, [
                                _createVNode(_component_Avatar, {
                                  icon: _ctx.typeDescriptor.icons.unread.icon,
                                  shape: "circle",
                                  size: "medium",
                                  style: _ctx.typeDescriptor.icons.unread.style
                                }, null, 8, ["icon", "style"])
                              ]))
                        ], 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["options"])
                  ]),
                  (Object.keys(_ctx.selectedNews).length != 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        (_ctx.loading)
                          ? (_openBlock(), _createBlock(_component_ProgressBar, {
                              key: 0,
                              mode: "indeterminate",
                              class: "kn-progress-bar",
                              "data-test": "progress-bar"
                            }))
                          : _createCommentVNode("", true),
                        _createVNode("h4", null, [
                          _createVNode("div", _hoisted_7, [
                            _createTextVNode(_toDisplayString(_ctx.$t('newsDialog.description')) + ": ", 1),
                            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.selectedNews.description), 1)
                          ]),
                          _createVNode("div", _hoisted_9, [
                            _createTextVNode(_toDisplayString(_ctx.$t('newsDialog.expirationDate')) + " : ", 1),
                            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.getDate()), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_11, [
                          _createVNode("p", {
                            innerHTML: _ctx.selectedNews.html,
                            disabled: ""
                          }, null, 8, ["innerHTML"])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('common.info.noElementSelected')), 1))
                ])
              ]),
              _: 2
            }, 1032, ["header"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "header"]))
})